import * as Sentry from "@sentry/react";
import { buildSentryInitOptions } from "@lib/sentry/config";

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN?.trim();

if (dsn) {
  Sentry.init(buildSentryInitOptions("web-client", dsn));
}
